import { useCallback, useMemo } from 'react';
import { SelectChangeEvent } from '@mui/material';
import { useLocations } from '../../Location.context';
import { useLocationFilter } from './LocationFilter.context';
import Select from '../../../../components/Molecules/Select';

const ALL_LOCATIONS_VALUE = '';

const LocationFilter = () => {
    const { locations, isError } = useLocations();
    const { selectedLocation, setSelectedLocation } = useLocationFilter();

    const handleLocationChange = useCallback(
        (e: SelectChangeEvent<string>) => setSelectedLocation(e.target.value),
        [setSelectedLocation],
    );

    const options = useMemo(() => {
        const allLocationsOption = {
            label: 'All Locations',
            id: ALL_LOCATIONS_VALUE,
        };

        const locationOptions = (locations?.map(location => ({
            label: location.name || 'Unknown Location',
            id: location.id?.toString() || '',
        })) || []).sort((a, b) =>
            a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }),
        );

        return [allLocationsOption, ...locationOptions];
    }, [locations]);

    return (
        <Select
            label="Location Selector"
            options={options}
            disabled={isError || !locations}
            onChange={handleLocationChange}
            value={selectedLocation || ALL_LOCATIONS_VALUE}
            defaultValue={ALL_LOCATIONS_VALUE}
        />
    );
};

export default LocationFilter;